/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { candidateExportLogDataStatusSchema } from './CandidateExportLogDataStatusSchema'

export const candidateExportLogDataSchema = z.object({
	id: z.string(),
	exportIntegrationId: z.string(),
	formSubmissionId: z.string(),
	campaignId: z.string(),
	externalCandidateId: z.string().nullable(),
	externalApplicationId: z.string().nullable(),
	status: candidateExportLogDataStatusSchema,
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
})

export type CandidateExportLogDataSchema = z.infer<typeof candidateExportLogDataSchema>
